import { DataGrid, type DataGridProps } from '@shared/components';

export type BaseAdminExamCourseDataGridProps = Omit<
  DataGridProps,
  'sx' | 'rowHeight' | 'getRowHeight' | 'disableColumnMenu'
>;

export default function BaseAdminExamCourseDataGrid(
  props: Readonly<BaseAdminExamCourseDataGridProps>,
) {
  return (
    <DataGrid
      {...props}
      disableColumnMenu
      getRowHeight={() => 'auto'}
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        minHeight: '100%',
        '& .MuiDataGrid-cell': {
          p: theme.spacing(3),
          alignItems: 'flex-start',
        },
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '& .MuiDataGrid-columnHeader': {
          px: theme.spacing(3),
        },
        '& .MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '--DataGrid-overlayHeight': '404px',
      })}
    />
  );
}
